import axios from "./requests";
// 合作方列表
export const partnerTableData = (data) => {
  return axios({
    url: '/api/v1/merchant/queryPartnerList',
    method: 'post',
    data,
    config: {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        timeout: 10000,
      },
    },
  })
}
// 添加合作方
export const addPartnerData = (data) => {
  return axios({
    url: '/api/v1/merchant/savePartner',
    method: 'post',
    data,
    config: {
      headers: {
        timeout: 10000,
        'accessToken': sessionStorage.getItem('token')
      },
    },
  })
}
// 编辑合作方
export const editPartnerData = (data) => {
  return axios({
    url: '/api/v1/merchant/editPartner',
    method: 'post',
    data,
    config: {
      headers: {
        timeout: 10000,
        'accessToken': sessionStorage.getItem('token')
      },
    },
  })
}
// 获取合作方信息
export const getPartnerDetail = (data) => {
  return axios({
    url: '/api/v1/merchant/queryPartnerInfo',
    method: 'post',
    data,
    config: {
      headers: {
        timeout: 10000,
        'Content-Type': 'application/x-www-form-urlencoded',
        'accessToken': sessionStorage.getItem('token')
      },
    },
  })
}
// 合作方列表
export const getpartnerData = (data) => {
  return axios({
    url: '/api/v1/merchant/queryPartnerCodeList',
    method: 'post',
    data,
    config: {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        timeout: 10000,
      },
    },
  })
}
// 供应商列表
export const supplierTableData = (data) => {
  return axios({
    url: '/api/v1/merchant/querySupplierPage',
    method: 'post',
    data,
    config: {
      headers: {
        timeout: 10000,
        'Content-Type': 'application/x-www-form-urlencoded',
        'accessToken': sessionStorage.getItem('token')
      },
    },
  })
}
// 添加供应商
export const addSupplier = (data) => {
  return axios({
    url: '/api/v1/merchant/saveSupplier',
    method: 'post',
    data,
    config: {
      headers: {
        timeout: 10000,
        'accessToken': sessionStorage.getItem('token')
      },
    },
  })
}
// 获取供货商信息
export const getSupplierDetail = (data) => {
  return axios({
    url: '/api/v1/merchant/querySupplierInfo',
    method: 'post',
    data,
    config: {
      headers: {
        timeout: 10000,
        'Content-Type': 'application/x-www-form-urlencoded',
        'accessToken': sessionStorage.getItem('token')
      },
    },
  })
}
// 编辑供应商
export const editSupplierData = (data) => {
  return axios({
    url: '/api/v1/merchant/editSupplier',
    method: 'post',
    data,
    config: {
      headers: {
        timeout: 10000,
        'accessToken': sessionStorage.getItem('token')
      },
    },
  })
}
// 周期任务
export const periodicTaskData = (data) => {
  return axios({
    url: '/api/v1/wangyi/queryInterfaceCycleLogPage',
    method: 'post',
    data,
    config: {
      headers: {
        timeout: 10000,
        'Content-Type': 'application/x-www-form-urlencoded',
        'accessToken': sessionStorage.getItem('token')
      },
    },
  })
}
// 单次任务
export const singleTaskData = (data) => {
  return axios({
    url: '/api/v1/wangyi/queryInterfaceLogPage',
    method: 'post',
    data,
    config: {
      headers: {
        timeout: 10000,
        'Content-Type': 'application/x-www-form-urlencoded',
        'accessToken': sessionStorage.getItem('token')
      },
    },
  })
}
// 操作数据
export const getOperationData = (data) => {
  return axios({
    url: '/api/v1/wangyi/queryInterfaceUpdateLogPage',
    method: 'post',
    data,
    config: {
      headers: {
        timeout: 10000,
        'Content-Type': 'application/x-www-form-urlencoded',
        'accessToken': sessionStorage.getItem('token')
      },
    },
  })
}
// 类目列表
export const platformCategoryData = (data) => {
  return axios({
    url: '/api/v1/category/queryPlatformCategoryList',
    method: 'post',
    data,
    config: {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        timeout: 10000,
      },
    },
  })
}
// 添加类目
export const addPlatformData = (data) => {
  return axios({
    url: '/api/v1/category/savePlatformCategory',
    method: 'post',
    data,
    config: {
      headers: {
        // 'Content-Type': 'application/x-www-form-urlencoded',
        timeout: 10000,
      },
    },
  })
}

export const platformInfo = (data) => {
  return axios({
    url: "/api/v1/category/queryPlatformCategoryInfo",
    method: "post",
    data,
    config: {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        timeout: 10000,
        'accessToken': sessionStorage.getItem('token')
      },
    },
  });
};
// 获取类目详情
export const getPlatformDetail = (data) => {
  return axios({
    url: '/api/v1/category/queryPlatformCategoryEditInfo',
    method: 'post',
    data,
    config: {
      headers: {
        timeout: 10000,
        'Content-Type': 'application/x-www-form-urlencoded',
        'accessToken': sessionStorage.getItem('token')
      },
    },
  })
}
// 编辑类目保存
export const editPlatformData = (data) => {
  return axios({
    url: '/api/v1/category/editPlatformCategory',
    method: 'post',
    data,
    config: {
      headers: {
        // 'Content-Type': 'application/x-www-form-urlencoded',
        timeout: 10000,
      },
    },
  })
}
// 网易类目列表
export const wangyiPlatformCategoryData = (data) => {
  return axios({
    url: '/api/v1/wangyi/queryCategoryList',
    method: 'post',
    data,
    config: {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        timeout: 10000,
         'accessToken': sessionStorage.getItem('token')
      },
    },
  })
}
// 获取网易类目详情
export const getWangyiPlatformDetail = (data) => {
  return axios({
    url: '/api/v1/wangyi/queryCategoryInfo',
    method: 'post',
    data,
    config: {
      headers: {
        timeout: 10000,
        'Content-Type': 'application/x-www-form-urlencoded',
        'accessToken': sessionStorage.getItem('token')
      },
    },
  })
}
// 编辑网易类目保存
export const editWangyiPlatformData = (data) => {
  return axios({
    url: '/api/v1/wangyi/editCategory',
    method: 'post',
    data,
    config: {
      headers: {
        // 'Content-Type': 'application/x-www-form-urlencoded',
        timeout: 10000,
      },
    },
  })
}
//获取网易商品
export const getwangyiGoodsData = (data) => {
  return axios({
    url: '/api/v1/wangyi/queryGoodsPage',
    method: 'post',
    data,
    config: {
      headers: {
        timeout: 10000,
        'Content-Type': 'application/x-www-form-urlencoded',
        'accessToken': sessionStorage.getItem('token')
      },
    },
  })
}
// 获取网易类目
export const getwangyiCategoryInfo = (data) => {
  return axios({
    url: "/api/v1/wangyi/queryPublicCategoryList",
    method: "post",
    data,
    config: {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        timeout: 10000,
        'accessToken': sessionStorage.getItem('token')
      },
    },
  });
};
// 删除工会  

export const Cancel = (data) => {
  return axios({
    url: '/ztunion/delete',
    method: 'delete',
    data,
    config: {
      headers: {
        timeout: 10000,
      },
    },
  })
}

// 修改工会名称

export const Modify = (data) => {
  return axios({
    url: '/ztunion/update',
    method: 'put',
    data,
    config: {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        timeout: 10000,
      },
    },
  })
}
/**
 * 订单管理2026年9月7日09:03:07
 */
// 查询组织列表
export const queryOrganizationList = (data) => {
  return axios({
    url: '/api/v1/searchCondition/queryOrganizationList',
    method: 'post',
    data,
    config: {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        timeout: 10000,
         'accessToken': sessionStorage.getItem('token')
      },
    },
  })
}
// 查询合作方列表
export const queryPartnerList = (data) => {
  return axios({
    url: '/api/v1/searchCondition/queryPartnerList',
    method: 'post',
    data,
    config: {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        timeout: 10000,
         'accessToken': sessionStorage.getItem('token')
      },
    },
  })
}
// 查询后台订单列表
export const queryOrderList = (data) => {
  return axios({
    url: '/api/v1/order/queryOrderList',
    method: 'post',
    data,
    config: {
      headers: {
        timeout: 10000,
        'Content-Type': 'application/json',
        'accessToken': sessionStorage.getItem('token')
      },
    },
  })
}
// 查询订单详情
export const queryOrderDetail = (data) => {
  return axios({
    url: '/api/v1/order/queryOrderDetail',
    method: 'post',
    data,
    config: {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        timeout: 10000,
         'accessToken': sessionStorage.getItem('token')
      },
    },
  })
}
// 创建商城文件导出任务
export const createExportTask = (data) => {
  return axios({
    url: '/api/v1/shopFileExport/createExportTask',
    method: 'post',
    data,
    config: {
      headers: {
        timeout: 10000,
        'Content-Type': 'application/json',
        'accessToken': sessionStorage.getItem('token')
      },
    },
  })
}
// 查询商城文件导出任务列表
export const queryExportTaskList = (data) => {
  return axios({
    url: '/api/v1/shopFileExport/queryExportTaskList',
    method: 'post',
    data,
    config: {
      headers: {
        timeout: 10000,
        'Content-Type': 'application/json',
        'accessToken': sessionStorage.getItem('token')
      },
    },
  })
}
// 查询网易严选品牌列表
export const queryWangYiBrandList = (data) => {
  return axios({
    url: '/api/v1/adminBrand/queryWangYiBrandList',
    method: 'post',
    data,
    config: {
      headers: {
        timeout: 10000,
        'Content-Type': 'application/json',
        'accessToken': sessionStorage.getItem('token')
      },
    },
  })
}
// 查询京东品牌列表
export const queryJingDongBrandList = (data) => {
  return axios({
    url: '/api/v1/adminBrand/queryJingDongBrandList',
    method: 'post',
    data,
    config: {
      headers: {
        timeout: 10000,
        'Content-Type': 'application/json',
        'accessToken': sessionStorage.getItem('token')
      },
    },
  })
}
// 查询京东余额
export const queryJingDongAccountBalance = (data) => {
  return axios({
    url: '/api/v1/adminBalance/queryJingDongAccountBalance',
    method: 'post',
    data,
    config: {
      headers: {
        timeout: 10000,
        'Content-Type': 'application/json',
        'accessToken': sessionStorage.getItem('token')
      },
    },
  })
}
// 分页查询京东商品SPU数据列表
export const queryJingdongGoodsList = (data) => {
  return axios({
    url: '/api/v1/adminGoods/queryJingdongGoodsList',
    method: 'post',
    data,
    config: {
      headers: {
        timeout: 10000,
        'Content-Type': 'application/json',
        'accessToken': sessionStorage.getItem('token')
      },
    },
  })
}
// 查询京东余额变动
export const queryJingDongBalanceChangeList = (data) => {
  return axios({
    url: '/api/v1/adminBalance/queryJingDongBalanceChangeList',
    method: 'post',
    data,
    config: {
      headers: {
        timeout: 10000,
        'Content-Type': 'application/json',
        'accessToken': sessionStorage.getItem('token')
      },
    },
  })
}
// 查询天马品牌列表
export const queryTianMaBrandList = (data) => {
  return axios({
    url: '/api/v1/adminBrand/queryTianMaBrandList',
    method: 'post',
    data,
    config: {
      headers: {
        timeout: 10000,
        'Content-Type': 'application/json',
        'accessToken': sessionStorage.getItem('token')
      },
    },
  })
}
// 分页查询天马商品SPU数据列表
export const queryTianmaGoodsList = (data) => {
  return axios({
    url: '/api/v1/adminGoods/queryTianmaGoodsList',
    method: 'post',
    data,
    config: {
      headers: {
        timeout: 10000,
        'Content-Type': 'application/json',
        'accessToken': sessionStorage.getItem('token')
      },
    },
  })
}
// 查询天马余额
export const queryAccountBalance = (data) => {
  return axios({
    url: '/api/v1/tianma/queryAccountBalance',
    method: 'post',
    data,
    config: {
      headers: {
        timeout: 10000,
        'Content-Type': 'application/json',
        'accessToken': sessionStorage.getItem('token')
      },
    },
  })
}
// 查询蛋糕叔叔余额
export const queryDanGaoShuShuAccountBalance = (data) => {
  return axios({
    url: '/api/v1/dangaoshushu/queryAccountBalance',
    method: 'post',
    data,
    config: {
      headers: {
        timeout: 10000,
        'Content-Type': 'application/json',
        'accessToken': sessionStorage.getItem('token')
      },
    },
  })
}
// 查询蛋糕叔叔品牌列表
export const queryDanGaoShuShuBrandList = (data) => {
  return axios({
    url: '/api/v1/adminBrand/queryDanGaoShuShuBrandList',
    method: 'post',
    data,
    config: {
      headers: {
        timeout: 10000,
        'Content-Type': 'application/json',
        'accessToken': sessionStorage.getItem('token')
      },
    },
  })
}
// 获取全部有效城市及在售 SPU 数量
export const dangaoQueryCityList = (data) => {
  return axios({
    url: '/api/v1/dangaoshushu/city/queryCityList',
    method: 'post',
    data,
    config: {
      headers: {
        timeout: 10000,
        'Content-Type': 'application/json',
        'accessToken': sessionStorage.getItem('token')
      },
    },
  })
}
// 查询京东全部层级的启用类目
export const jingdongCategoryTreeList = (data) => {
  return axios({
    url: '/api/v1/jingdong/category/queryCategoryTreeList',
    method: 'post',
    data,
    config: {
      headers: {
        timeout: 10000,
        'Content-Type': 'application/json',
        'accessToken': sessionStorage.getItem('token')
      },
    },
  })
}
// 查询天马全部层级的启用类目
export const tianmaQueryCategoryTreeList = (data) => {
  return axios({
    url: '/api/v1/tianma/category/queryCategoryTreeList',
    method: 'post',
    data,
    config: {
      headers: {
        timeout: 10000,
        'Content-Type': 'application/json',
        'accessToken': sessionStorage.getItem('token')
      },
    },
  })
}
// 查询京东筛选后 SPU 和 SKU 总数
export const queryJingDongGoodsCount = (data) => {
  return axios({
    url: '/api/v1/adminGoods/queryJingDongGoodsCount',
    method: 'post',
    data,
    config: {
      headers: {
        timeout: 10000,
        'Content-Type': 'application/json',
        'accessToken': sessionStorage.getItem('token')
      },
    },
  })
}
// 查询天马筛选后 SPU 和 SKU 总数
export const queryTianMaGoodsCount = (data) => {
  return axios({
    url: '/api/v1/adminGoods/queryTianMaGoodsCount',
    method: 'post',
    data,
    config: {
      headers: {
        timeout: 10000,
        'Content-Type': 'application/json',
        'accessToken': sessionStorage.getItem('token')
      },
    },
  })
}
// 查询展开指定上线 SPU 的 SKU 列表
export const queryGoodsSkuList = (data) => {
  return axios({
    url: '/api/v1/adminGoods/queryGoodsSkuList',
    method: 'post',
    data,
    config: {
      headers: {
        timeout: 10000,
        'Content-Type': 'application/json',
        'accessToken': sessionStorage.getItem('token')
      },
    },
  })
}
// 查询指定上线 SPU 的详情
export const queryGoodsDetail = (data) => {
  return axios({
    url: '/api/v1/adminGoods/queryGoodsDetail',
    method: 'post',
    data,
    config: {
      headers: {
        timeout: 10000,
        'Content-Type': 'application/json',
        'accessToken': sessionStorage.getItem('token')
      },
    },
  })
}